import Calendar from "./Calendar";
function App() {
    return (
        <div id="body" style={{ width: "100%" }}>
            <Calendar />
        </div>
    );
}
export default App;
